import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { EmptyState } from '../components/record/RecordPage.tsx';
import { useMailAccounts } from '../settings/useMailAccounts.ts';

// An empty list means different things: no mailbox, tracking switched off, or
// tracked mail with nobody in it. Existing mailboxes start switched off.
export const NoRelationshipHistory = ({ who }: { who: string }) => {
  const { accounts, loading, error } = useMailAccounts();
  if (loading) return null;

  if (error || accounts.some((account) => account.touchScanEnabled)) {
    return <EmptyState>Nobody at the firm has emailed {who} in the last year.</EmptyState>;
  }

  const settings = (
    <MuiLink component={RouterLink} to="/settings">
      Settings
    </MuiLink>
  );
  return (
    <EmptyState>
      {accounts.length ? (
        <>
          Relationship tracking is off for your mailbox. Turn it on in {settings} to see who at the
          firm knows {who}.
        </>
      ) : (
        <>
          Connect a mailbox in {settings} to see who at the firm knows {who}.
        </>
      )}
    </EmptyState>
  );
};
